import HomeRedirect from './HomeRedirect';

export default HomeRedirect;
